import { message } from "antd";
import axiosInstance from "../axiosInstance";
import { PAGE_SIZE } from "../constants";

import {
	FETCH_ADMINS_REQUEST,
	FETCH_ADMINS_SUCCESS,
	FETCH_ADMINS_FAIL,
	UPDATE_ADMIN_REQUEST,
	UPDATE_ADMIN_SUCCESS,
	UPDATE_ADMIN_FAIL,
	FETCH_ADMIN_REQUEST,
	FETCH_ADMIN_SUCCESS,
	FETCH_ADMIN_FAIL,
	CREATE_ADMIN_REQUEST,
	CREATE_ADMIN_SUCCESS,
	CREATE_ADMIN_FAIL,
	DELETE_ADMIN_REQUEST,
	DELETE_ADMIN_SUCCESS,
	DELETE_ADMIN_FAIL,
} from "../constants/admin";

const fetchAdmins = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_ADMINS_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/admins", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		dispatch({
			type: FETCH_ADMINS_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_ADMINS_FAIL, payload: errorMessage });
	}
};

const updateAdmin = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_ADMIN_REQUEST });
	try {
		const { data } = await axiosInstance.patch(`/admin/admins/${id}`, values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Updated.");
		dispatch({
			type: UPDATE_ADMIN_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_ADMIN_FAIL, payload: errorMessage });
	}
};

const fetchAdmin = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_ADMIN_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/admins/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_ADMIN_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_ADMIN_FAIL, payload: errorMessage });
	}
};

const createAdmin = (values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: CREATE_ADMIN_REQUEST });
	try {
		const { data } = await axiosInstance.post("/admin/admins", values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		message.success("Created.");
		dispatch(fetchAdmins({ start: 0, count: PAGE_SIZE }));
		dispatch({
			type: CREATE_ADMIN_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: CREATE_ADMIN_FAIL, payload: errorMessage });
	}
};

const deleteAdmin = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DELETE_ADMIN_REQUEST });
	try {
		const { data } = await axiosInstance.delete(`/admin/admins/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Deleted.");
		dispatch({
			type: DELETE_ADMIN_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DELETE_ADMIN_FAIL, payload: errorMessage });
	}
};

export { fetchAdmins, updateAdmin, fetchAdmin, createAdmin, deleteAdmin };
